// extracted by mini-css-extract-plugin
export default {"root":"RemoveAllDuplicatesTooltip__root--1NMix"};